import { inject, Injectable } from '@angular/core'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import { Environment, ENVIRONMENT } from '@wm-front/shared/environment'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SvgIcon } from '@wm-front/shared/interfaces'

@Injectable()
export class SvgIconService {
  public customIcons: SvgIcon[] = [
    {
      iconName: 'show-sm',
      fileName: 'show-sm.svg',
    },
    {
      iconName: 'hide-sm',
      fileName: 'hide-sm.svg',
    },
    {
      iconName: 'email-sent-xl',
      fileName: 'email-sent-xl.svg',
    },
    {
      iconName: 'notification-sm',
      fileName: 'notification-sm.svg',
    },
    {
      iconName: 'reduce-sm',
      fileName: 'reduce-sm.svg',
    },
    {
      iconName: 'reduce-xs',
      fileName: 'reduce-xs.svg',
    },
    {
      iconName: 'about-xs',
      fileName: 'about-xs.svg',
    },
    {
      iconName: 'back-arrow',
      fileName: 'back-arrow.svg',
    },
    {
      iconName: 'breakdown-md',
      fileName: 'breakdown-md.svg',
    },
    {
      iconName: 'contract-md',
      fileName: 'contract-md.svg',
    },
    {
      iconName: 'deadline-sm',
      fileName: 'deadline-sm.svg',
    },
    {
      iconName: 'deadline-md',
      fileName: 'deadline-md.svg',
    },
    {
      iconName: 'car-lift-sm',
      fileName: 'car-lift-sm.svg',
    },
    {
      iconName: 'pmr-sm',
      fileName: 'pmr-sm.svg',
    },
    {
      iconName: 'hoist-sm',
      fileName: 'hoist-sm.svg',
    },
    {
      iconName: 'elevator-sm',
      fileName: 'elevator-sm.svg',
    },
    {
      iconName: 'elevator-xs',
      fileName: 'elevator-xs.svg',
    },
    {
      iconName: 'doors-xs',
      fileName: 'doors-xs.svg',
    },
    {
      iconName: 'doors-md',
      fileName: 'doors-md.svg',
    },
    {
      iconName: 'escalator-xs',
      fileName: 'escalator-xs.svg',
    },
    {
      iconName: 'fire-xs',
      fileName: 'fire-xs.svg',
    },
    {
      iconName: 'fire-sm',
      fileName: 'fire-sm.svg',
    },
    {
      iconName: 'hoist-xs',
      fileName: 'hoist-xs.svg',
    },
    {
      iconName: 'pmr-xs',
      fileName: 'pmr-xs.svg',
    },
    {
      iconName: 'car-lift-md',
      fileName: 'car-lift-md.svg',
    },
    {
      iconName: 'pmr-md',
      fileName: 'pmr-md.svg',
    },
    {
      iconName: 'hoist-md',
      fileName: 'hoist-md.svg',
    },
    {
      iconName: 'elevator-md',
      fileName: 'elevator-md.svg',
    },
    {
      iconName: 'search-sm',
      fileName: 'search-sm.svg',
    },
    {
      iconName: 'search-lg',
      fileName: 'search-lg.svg',
    },
    {
      iconName: 'search-xl',
      fileName: 'search-xl.svg',
    },
    {
      iconName: 'iot-sm',
      fileName: 'iot-sm.svg',
    },
    {
      iconName: 'iot-xs',
      fileName: 'iot-xs.svg',
    },
    {
      iconName: 'alert-xs',
      fileName: 'alert-xs.svg',
    },
    {
      iconName: 'alert-sm',
      fileName: 'alert-sm.svg',
    },
    {
      iconName: 'alert-md',
      fileName: 'alert-md.svg',
    },
    {
      iconName: 'error-circle-sm',
      fileName: 'error-circle-sm.svg',
    },
    {
      iconName: 'close-sm',
      fileName: 'close-sm.svg',
    },
    {
      iconName: 'close-xs',
      fileName: 'close-xs.svg',
    },
    {
      iconName: 'filter-sm',
      fileName: 'filter-sm.svg',
    },
    {
      iconName: 'validate-sm',
      fileName: 'validate-sm.svg',
    },
    {
      iconName: 'validate-xs',
      fileName: 'validate-xs.svg',
    },
    {
      iconName: 'download-sm',
      fileName: 'download-sm.svg',
    },
    {
      iconName: 'arrow-bottom-sm',
      fileName: 'arrow-bottom-sm.svg',
    },
    {
      iconName: 'download-xs',
      fileName: 'download-xs.svg',
    },
    {
      iconName: 'anomaly-xl',
      fileName: 'anomaly-xl.svg',
    },
    {
      iconName: 'contact-sm',
      fileName: 'contact-sm.svg',
    },
    {
      iconName: 'arrow-top-sm',
      fileName: 'arrow-top-sm.svg',
    },
    {
      iconName: 'picture-sm',
      fileName: 'picture-sm.svg',
    },
    {
      iconName: 'picture-md',
      fileName: 'picture-md.svg',
    },
    {
      iconName: 'picture-lg',
      fileName: 'picture-lg.svg',
    },
    {
      iconName: 'menu-sm',
      fileName: 'menu-sm.svg',
    },
    {
      iconName: 'on',
      fileName: 'on.svg',
    },
    {
      iconName: 'off',
      fileName: 'off.svg',
    },
    {
      iconName: 'password-updated-xl',
      fileName: 'password-updated-xl.svg',
    },
    {
      iconName: 'arrow-paginator',
      fileName: 'arrow-paginator.svg',
    },
    {
      iconName: 'arrow-paginator-active',
      fileName: 'arrow-paginator-active.svg',
    },
    {
      iconName: 'arrow-right-xs',
      fileName: 'arrow-right-xs.svg',
    },
    {
      iconName: 'arrow-slim-md',
      fileName: 'arrow-slim-md.svg',
    },
    {
      iconName: 'error-500-xl',
      fileName: 'error-500-xl.svg',
    },
    {
      iconName: 'design-xl',
      fileName: 'design-xl.svg',
    },
    {
      iconName: 'google-icon',
      fileName: 'google-icon.svg',
    },
    {
      iconName: 'add-sm',
      fileName: 'add-sm.svg',
    },
    {
      iconName: 'remove-sm',
      fileName: 'remove-sm.svg',
    },
    {
      iconName: 'add-xs',
      fileName: 'add-xs.svg',
    },
    {
      iconName: 'remove-xs',
      fileName: 'remove-xs.svg',
    },
    {
      iconName: 'repair-sm',
      fileName: 'repair-sm.svg',
    },
    {
      iconName: 'repair-xs',
      fileName: 'repair-xs.svg',
    },
    {
      iconName: 'trash-sm',
      fileName: 'trash-sm.svg',
    },
    {
      iconName: 'party-xl',
      fileName: 'party-xl.svg',
    },
    {
      iconName: 'time-xs',
      fileName: 'time-xs.svg',
    },
    {
      iconName: 'time-sm',
      fileName: 'time-sm.svg',
    },
    {
      iconName: 'trophy-sm',
      fileName: 'trophy-sm.svg',
    },
    {
      iconName: 'intervention-xs',
      fileName: 'intervention-xs.svg',
    },
    {
      iconName: 'intervention-sm',
      fileName: 'intervention-sm.svg',
    },
    {
      iconName: 'intervention-xl',
      fileName: 'intervention-xl.svg',
    },
    {
      iconName: 'billing-sm',
      fileName: 'billing-sm.svg',
    },
    {
      iconName: 'mission-infos-sm',
      fileName: 'mission-infos-sm.svg',
    },
    {
      iconName: 'files-xl',
      fileName: 'files-xl.svg',
    },
    {
      iconName: 'label-sm',
      fileName: 'label-sm.svg',
    },
    {
      iconName: 'calendar-sm',
      fileName: 'calendar-sm.svg',
    },
    {
      iconName: 'statistics-sm',
      fileName: 'statistics-sm.svg',
    },
    {
      iconName: 'combined-shape-sm',
      fileName: 'combined-shape-sm.svg',
    },
    {
      iconName: 'padlock-sm',
      fileName: 'padlock-sm.svg',
    },
    {
      iconName: 'arrow-menu-right',
      fileName: 'arrow-menu-right.svg',
    },
    {
      iconName: 'profile-sm',
      fileName: 'profile-sm.svg',
    },
    {
      iconName: 'profile-md',
      fileName: 'profile-md.svg',
    },
    {
      iconName: 'upload-md',
      fileName: 'upload-md.svg',
    },
    {
      iconName: 'attachment-sm',
      fileName: 'attachment-sm.svg',
    },
    {
      iconName: 'audit-md',
      fileName: 'audit-md.svg',
    },
    {
      iconName: 'audit-sm',
      fileName: 'audit-sm.svg',
    },
    {
      iconName: 'document-sm',
      fileName: 'document-sm.svg',
    },
    {
      iconName: 'dollar-xs',
      fileName: 'dollar-xs.svg',
    },
    {
      iconName: 'document-xs',
      fileName: 'document-xs.svg',
    },
    {
      iconName: 'mail-sm',
      fileName: 'mail-sm.svg',
    },
    {
      iconName: 'mail-xs',
      fileName: 'mail-xs.svg',
    },
    {
      iconName: 'buildings-sm',
      fileName: 'buildings-sm.svg',
    },
    {
      iconName: 'language-xs',
      fileName: 'language-xs.svg',
    },
    {
      iconName: 'log-out-xs',
      fileName: 'log-out-xs.svg',
    },
    {
      iconName: 'language-sm',
      fileName: 'language-sm.svg',
    },
    {
      iconName: 'locate-xs',
      fileName: 'locate-xs.svg',
    },
    {
      iconName: 'locate-sm',
      fileName: 'locate-sm.svg',
    },
    {
      iconName: 'burger-menu-sm',
      fileName: 'burger-menu-sm.svg',
    },
    {
      iconName: 'back-sm',
      fileName: 'back-sm.svg',
    },
    {
      iconName: 'dashboard-xl',
      fileName: 'dashboard-xl.svg',
    },
    {
      iconName: 'bulb-xs',
      fileName: 'bulb-xs.svg',
    },
    {
      iconName: 'briefcase-sm',
      fileName: 'briefcase-sm.svg',
    },
    {
      iconName: 'day-off-xl',
      fileName: 'day-off-xl.svg',
    },
    {
      iconName: 'files-md',
      fileName: 'files-md.svg',
    },
    {
      iconName: 'certificate-sm',
      fileName: 'certificate-sm.svg',
    },
    {
      iconName: 'arrow-right-sm',
      fileName: 'arrow-right-sm.svg',
    },
    {
      iconName: 'escalator-sm',
      fileName: 'escalator-sm.svg',
    },
    {
      iconName: 'travellator-sm',
      fileName: 'travellator-sm.svg',
    },
    {
      iconName: 'link-xs',
      fileName: 'link-xs.svg',
    },
    {
      iconName: 'link-sm',
      fileName: 'link-sm.svg',
    },
    {
      iconName: 'forbidden-sm',
      fileName: 'forbidden-sm.svg',
    },
    {
      iconName: 'validation-medal-lg',
      fileName: 'validation-medal-lg.svg',
    },
    {
      iconName: 'pin-sm',
      fileName: 'pin-sm.svg',
    },
    {
      iconName: 'parc-sm',
      fileName: 'parc-sm.svg',
    },
    {
      iconName: 'edit-sm',
      fileName: 'edit-sm.svg',
    },
    {
      iconName: 'questions-sm',
      fileName: 'questions-sm.svg',
    },
    {
      iconName: 'line-break-sm',
      fileName: 'line-break-sm.svg',
    },
    {
      iconName: 'info-xs',
      fileName: 'info-xs.svg',
    },
    {
      iconName: 'minus',
      fileName: 'minus.svg',
    },
    {
      iconName: 'plus',
      fileName: 'plus.svg',
    },
    {
      iconName: 'maximize-sm',
      fileName: 'maximize-sm.svg',
    },
    {
      iconName: 'hvac-xs',
      fileName: 'hvac-xs.svg',
    },
    {
      iconName: 'visit-sm',
      fileName: 'visit-sm.svg',
    },
    {
      iconName: 'pause-xs',
      fileName: 'pause-xs.svg',
    },
    {
      iconName: 'unpause-xs',
      fileName: 'unpause-xs.svg',
    },
    {
      iconName: 'mechanic-arrival-md',
      fileName: 'mechanic-arrival-md.svg',
    },
    {
      iconName: 'comment-md',
      fileName: 'comment-md.svg',
    },
    {
      iconName: 'mechanic-leave-md',
      fileName: 'mechanic-leave-md.svg',
    },
    {
      iconName: 'checkbox-xs',
      fileName: 'checkbox-xs.svg',
    },
    {
      iconName: 'radio-xs',
      fileName: 'radio-xs.svg',
    },
    {
      iconName: 'external-xs',
      fileName: 'external-xs.svg',
    },
    {
      iconName: 'refresh-xs',
      fileName: 'refresh-xs.svg',
    },
    {
      iconName: 'copy-sm',
      fileName: 'copy-sm.svg',
    },
    {
      iconName: 'quote-sm',
      fileName: 'quote-sm.svg',
    },
    {
      iconName: 'blank-netsuite-xs',
      fileName: 'blank-netsuite-xs.svg',
    },
    {
      iconName: 'calculator-xs',
      fileName: 'calculator-xs.svg',
    },
    {
      iconName: 'cart-xs',
      fileName: 'cart-xs.svg',
    },
    {
      iconName: 'check-sf-xs',
      fileName: 'check-sf-xs.svg',
    },
    {
      iconName: 'delivery-xs',
      fileName: 'delivery-xs.svg',
    },
    {
      iconName: 'nut-xs',
      fileName: 'nut-xs.svg',
    },
    {
      iconName: 'package-xs',
      fileName: 'package-xs.svg',
    },
    {
      iconName: 'paperplane-xs',
      fileName: 'paperplane-xs.svg',
    },
    {
      iconName: 'part-collecting-xs',
      fileName: 'part-collecting-xs.svg',
    },
    {
      iconName: 'sending-xs',
      fileName: 'sending-xs.svg',
    },
    {
      iconName: 'select-xs',
      fileName: 'select-xs.svg',
    },
    {
      iconName: 'exclamation-xs',
      fileName: 'exclamation-xs.svg',
    },
    {
      iconName: 'point-xs',
      fileName: 'point-xs.svg',
    },
    {
      iconName: 'redo-xs',
      fileName: 'redo-xs.svg',
    },
    {
      iconName: 'verified-xs',
      fileName: 'verified-xs.svg',
    },
    {
      iconName: 'assign-engineer-sm',
      fileName: 'assign-engineer-sm.svg',
    },
    {
      iconName: 'engineer-sm',
      fileName: 'engineer-sm.svg',
    },
    {
      iconName: 'new-event-sm',
      fileName: 'new-event-sm.svg',
    },
    {
      iconName: 'see-calendar-sm',
      fileName: 'see-calendar-sm.svg',
    },
    {
      iconName: 'sorted-list-sm',
      fileName: 'sorted-list-sm.svg',
    },
    {
      iconName: 'external-sm',
      fileName: 'external-sm.svg',
    },
    {
      iconName: 'comment-sm',
      fileName: 'comment-sm.svg',
    },
    {
      iconName: 'alert-lg',
      fileName: 'reports/visits/summary/alert-lg.svg',
    },
    {
      iconName: 'repaired-lg',
      fileName: 'reports/visits/summary/repaired-lg.svg',
    },
    {
      iconName: 'valid-lg',
      fileName: 'reports/visits/summary/valid-lg.svg',
    },
    {
      iconName: 'success-lg',
      fileName: 'reports/visits/summary/success-lg.svg',
    },
    {
      iconName: 'car-lg',
      fileName: 'reports/visits/questions/categories/car-lg.svg',
    },
    {
      iconName: 'controller-lg',
      fileName: 'reports/visits/questions/categories/controller-lg.svg',
    },
    {
      iconName: 'default-lg',
      fileName: 'reports/visits/questions/categories/default-lg.svg',
    },
    {
      iconName: 'doors-lg',
      fileName: 'reports/visits/questions/categories/doors-lg.svg',
    },
    {
      iconName: 'safety-lg',
      fileName: 'reports/visits/questions/categories/safety-lg.svg',
    },
    {
      iconName: 'level-lg',
      fileName: 'reports/visits/questions/categories/level-lg.svg',
    },
    {
      iconName: 'lower-landing-lg',
      fileName: 'reports/visits/questions/categories/lower-landing-lg.svg',
    },
    {
      iconName: 'motor-room-lg',
      fileName: 'reports/visits/questions/categories/motor-room-lg.svg',
    },
    {
      iconName: 'pulley-lg',
      fileName: 'reports/visits/questions/categories/pulley-lg.svg',
    },
    {
      iconName: 'sensor-doors-lg',
      fileName: 'reports/visits/questions/categories/sensor-doors-lg.svg',
    },
    {
      iconName: 'shaft-lg',
      fileName: 'reports/visits/questions/categories/shaft-lg.svg',
    },
    {
      iconName: 'top-of-car-lg',
      fileName: 'reports/visits/questions/categories/top-of-car-lg.svg',
    },
    {
      iconName: 'upper-landing-lg',
      fileName: 'reports/visits/questions/categories/upper-landing-lg.svg',
    },
    {
      iconName: 'general-lg',
      fileName: 'reports/visits/questions/categories/general-lg.svg',
    },
    {
      iconName: 'fs-lg',
      fileName: 'reports/visits/questions/categories/fs-lg.svg',
    },
    {
      iconName: 'incline-lg',
      fileName: 'reports/visits/questions/categories/incline-lg.svg',
    },
    {
      iconName: 'alert-sub-xs',
      fileName: 'reports/visits/questions/sub-categories/alert-sub-xs.svg',
    },
    {
      iconName: 'info-sub-xs',
      fileName: 'reports/visits/questions/sub-categories/info-sub-xs.svg',
    },
    {
      iconName: 'repair-sub-xs',
      fileName: 'reports/visits/questions/sub-categories/repair-sub-xs.svg',
    },
    {
      iconName: 'validate-sub-xs',
      fileName: 'reports/visits/questions/sub-categories/validate-sub-xs.svg',
    },
    {
      iconName: 'arrow-down-right-xs',
      fileName:
        'reports/visits/questions/sub-categories/arrow-down-right-xs.svg',
    },
    {
      iconName: 'increase-xs',
      fileName: 'increase-xs.svg',
    },
    {
      iconName: 'unlink-xs',
      fileName: 'unlink-xs.svg',
    },
    {
      iconName: 'ai-xs',
      fileName: 'ai-xs.svg',
    },
    {
      iconName: 'ai2-xs',
      fileName: 'ai2-xs.svg',
    },
    {
      iconName: 'engineer-md',
      fileName: 'engineer-md.svg',
    },
    {
      iconName: 'ops-md',
      fileName: 'ops-md.svg',
    },
    {
      iconName: 'bullet-list-xs',
      fileName: 'bullet-list-xs.svg',
    },
    {
      iconName: 'numbered-list-xs',
      fileName: 'numbered-list-xs.svg',
    },
  ]

  protected readonly matIconRegistry = inject(MatIconRegistry)

  protected readonly domSanitizer = inject(DomSanitizer)

  private env = inject<Environment>(ENVIRONMENT)

  constructor() {
    this._init()
  }

  protected _init(): void {
    this.customIcons.forEach((icon: SvgIcon): void => {
      this.matIconRegistry.addSvgIcon(
        icon.iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `assets/icons/${this.env.production ? 'optimized/' : ''}${
            icon.fileName
          }`
        )
      )
    })
  }
}
